import { ValidatorFn } from "@angular/forms";
import {SortDirection} from '../../core/utils/sort-utils';

export interface TableColumn {
  name: string;
  width?: string;
  widthMobile?:string;
  align?: 'left' | 'right' | 'center';
  left?: boolean;
  right?: boolean;
  checkbox?: boolean;
  pathData?: {
    name: string,
    type: 'text' | 'number' | 'date' | 'select' | 'boolean' | 'multi-select'| 'image' | 'avatar-select' | 'icon-select' | 'money-rate'|'checkboxOnTable'|'badge',
    reverseRate?: boolean,
    nestedPath?: string,
    dateFormat?: string,
  };
  optionList?: any[];
  validators?: {function: ValidatorFn, message: string,error:string}[];
  defaultValue?: any;
  noVisibleInTable?: boolean;
  noVisibleInForm?: boolean;
  showBorder?: boolean;

  // Propiedades para ordenamiento personalizado
  sortable?: boolean;
  sortFn?: () => void;
  sortDirection?: SortDirection;
  ///
  checkboxOnTable?: boolean;
  checkboxSelection?: {
    selectedIds: number[];
    onSelectAll: (selected: boolean) => void;
    onSelectItem: (id: number, selected: boolean) => void;
  };
}
